module.exports = __webpack_public_path__ + "img/l_dq.ecb6d660.png";